import React from "react";
import { Subheading } from "../../../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../design/table";
import UploadFileButton from "../UploadParentFileButton";
import { useParent } from "../../../../contexts/ParentContext";
import ParentDetailFileListItem from "./ParentDetailFileListItem";
import FilesLearnMore from "../../../../components/LearnMores/FilesLearnMore";

interface Props {
  parentId: string;
}

const ParentDetailFileList: React.FC<Props> = ({ parentId }) => {
  const { files } = useParent();
  return (
    <>
      <div className="flex flex-wrap items-end justify-between w-full">
        <div className="flex items-center gap-1 mt-12">
          <Subheading>Files</Subheading>
          <FilesLearnMore type="parent" />
        </div>
        <div className="flex gap-4">
          <UploadFileButton parentId={parentId} />
        </div>
      </div>
      {files.length === 0 && (
        <div className="mt-8 text-center">
          <Subheading>No Files found</Subheading>
        </div>
      )}
      {files.length > 0 && (
        <Table className="mt-4 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader>File</TableHeader>
              <TableHeader>Description</TableHeader>
              <TableHeader className="text-center">
                Visible to Supervisor
              </TableHeader>
              <TableHeader className="text-right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {files.map((file) => (
              <ParentDetailFileListItem
                key={file.id}
                file={file}
                parentId={parentId}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default ParentDetailFileList;
